import { Row, Col, Form, Stack } from "react-bootstrap";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import CustomButton from "../../../components/Common/Button/Button";
import { useEffect, useRef, useState } from "react";
import {
  assignDistributorRoles,
  fullAccessDistributorRoles,
  StatusCode,
  userPermissionsDistributor,
} from "../../../services/helper";
import { fetchLocation } from "../../../redux/slice/CreateNewUserSlice";
import { useDispatch, useSelector } from "react-redux";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  createNewUser,
  fetchUserManagementDataById,
  updateUserManagementData,
} from "../../../redux/slice/UserManagementSlice";
import "./index.css";
import { toast } from "react-toastify";
import image from "../../../Assets/Profile/Icon.svg";
import { FormControlLabel } from "@mui/material";
import { StyledSwitch } from "../../../components/CustomMUIComponents";
import TrashIcon from "../../../Assets/svg/trash-icon.svg";
import { permissions } from "../../../utils/helperFunction";
import Loader from "../../../components/Common/Loader/PrimaryLoader";
import ValidationSchema from "../../../components/Common/ValidationSchema";

function ManageDistributor() {
  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);

  //ref
  const whiteLogoRef = useRef();
  //redux state
  const { status } = useSelector((state) => state.USERMANAGEMENT);
  const { FetchLocationData } = useSelector(
    (state) => state.CREATEUSERANDLOCATION
  );

  //router functions
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(id ? true : false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //formik init values
  const initialValues = {
    first_name: "",
    last_name: "",
    location_id: "",
    contact_number: "",
    country_code: "+44",
    employee_id: "",
    job_title: "",
    assigned_role: "",
    permissions: [],
    email: "",
    profile_pic: null,
  };

  const handleCreatePermission = (permission) => {
    if (permission.length === userPermissionsDistributor.length) {
      return [permissions.dist_super_admin];
    } else {
      return permission;
    }
  };

  const handleSetPermission = (permission) => {
    if (permission.length > 0) {
      if (permission.includes(permissions.dist_super_admin)) {
        const permissions = userPermissionsDistributor.map((per) => per.id);
        return permissions;
      } else {
        return permission;
      }
    } else {
      return [];
    }
  };

  //formik functions
  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    setValues,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema.createNewUser,
    onSubmit: async (values) => {
      const payload = {
        ...values,
        permissions: handleCreatePermission(values.permissions),
      };
      if (id) {
        dispatch(updateUserManagementData({ values: { ...payload }, id })).then(
          (response) => {
            if (response?.payload?.status === 200) {
              navigate("/distributor-user-management");
            }
          }
        );
      } else {
        const res = await dispatch(createNewUser({ payload, cb: () => {} }));
        if (res?.payload?.status === 200) {
          navigate("/distributor-user-management");
        }
      }
    },
  });

  useEffect(() => {
    dispatch(fetchLocation());
    if (id) {
      setIsLoading(true);
      dispatch(fetchUserManagementDataById(id))
        .then((res) => {
          try {
            const result = res?.payload;
            const data = result?.data?.user_details ?? {};
            if (result?.status === 200) {
              setValues({
                first_name: data?.first_name || "",
                last_name: data?.last_name || "",
                email: data?.email || "",
                country_code: data?.country_code || "",
                contact_number: data?.contact_number || "",
                job_title: data?.job_title || "",
                employee_id: data?.employee_id || "",
                location_id: data?.location_id || "",
                assigned_role: data?.assigned_role || "",
                profile_pic: data?.profile_pic || "",
                permissions: handleSetPermission(data?.permissions ?? []),
              });
            }
          } catch (error) {
            console.error("Error processing distributor details:", error);
            // Optionally, handle errors or show an alert to the user
          }
        })
        .catch((error) => {
          console.error("Error dispatching action:", error);
          // Handle any errors related to the dispatch itself
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [id]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        setCompanyLogoPreview(URL.createObjectURL(file));
        setValues({ ...values, profile_pic: file });
      } else {
        toast.error("Please select a valid image file");
      }
    }
  };

  const handlePermissionChange = (event) => {
    const permissionId = event.target.id;
    const isChecked = event.target.checked;
    if (isChecked) {
      setValues({
        ...values,
        permissions: [...values.permissions, permissionId],
      });
    } else {
      setValues({
        ...values,
        permissions: values.permissions.filter((id) => id !== permissionId),
      });
    }
  };

  const handleChangeValues = (e) => {
    const { value, name } = e.target;
    if (fullAccessDistributorRoles.includes(value)) {
      setValues({
        ...values,
        [name]: value,
        permissions: userPermissionsDistributor.map(
          (permission) => permission.id
        ),
      });
    } else {
      setValues({
        ...values,
        [name]: value,
        permissions: userPermissionsDistributor
          .slice(-1)
          .map((permission) => permission.id),
      });
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Form
      onSubmit={handleSubmit}
      className="flex-grow-1 d-flex flex-column bg-white popup-layout"
    >
      <Stack className="h-100">
        <div
          className="position-sticky bg-white header-section"
          style={{ zIndex: 1 }}
        >
          <h4 className="text-center m-0 fw-bold">
            {id ? "Manage" : "New"} Team Member
          </h4>
          <hr className="my-3 my-md-4" />
        </div>
        <Row className="row-gap-3 pt-0 pt-md-1">
          <Col md={4}>
            <div className="d-flex flex-column align-items-center row-gap-2">
              <Form.Group className="mb-3" controlId="formBasicProfile_pic">
                <Form.Control
                  ref={whiteLogoRef}
                  type="file"
                  accept="image/*"
                  name="profile_pic"
                  className="d-none"
                  onChange={handleLogoChange}
                />
              </Form.Group>
              <img
                src={
                  companyLogoPreview
                    ? companyLogoPreview
                    : values.profile_pic || image
                }
                alt="profile_pic logo"
                className="custom_image w-100"
                style={{ maxHeight: "250px" }}
              />
              <button
                className="border-0 background-transparent"
                type="button"
                onClick={() => whiteLogoRef.current.click()}
              >
                Edit
              </button>
            </div>
          </Col>
          <Col md={8}>
            <Row className="row-gap-3">
              <Form.Group
                className="col-12 col-sm-6"
                controlId="formBasicFirstName"
              >
                <Form.Control
                  type="text"
                  name="first_name"
                  value={values.first_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="First Name"
                />
                {errors.first_name && touched.first_name && (
                  <p className="text-danger mt-1 mb-0">{errors.first_name}</p>
                )}
              </Form.Group>
              <Form.Group
                className="col-12 col-sm-6"
                controlId="formBasicLastName"
              >
                <Form.Control
                  type="text"
                  name="last_name"
                  value={values.last_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Last Name"
                />
                {errors.last_name && touched.last_name && (
                  <p className="text-danger mt-1 mb-0">{errors.last_name} </p>
                )}
              </Form.Group>
              <Form.Group
                className="col-12 col-sm-6"
                controlId="formBasicBusinessEmail"
              >
                <Form.Control
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Business Email"
                />
                {errors.email && touched.email && (
                  <p className="text-danger mt-1 mb-0">{errors.email} </p>
                )}
              </Form.Group>
              <Form.Group
                className="col-12 col-sm-6"
                controlId="formBasicLocation_id"
              >
                <Form.Select
                  aria-label="Default select example"
                  name="location_id"
                  onChange={handleChange}
                  value={values.location_id}
                >
                  <option value="" disabled className="option-title">
                    Office Location
                  </option>
                  {FetchLocationData &&
                    FetchLocationData?.locations?.map((curElm) => (
                      <option value={curElm._id} key={curElm._id}>
                        {curElm.location_name}
                      </option>
                    ))}
                </Form.Select>
                {errors.location_id && touched.location_id && (
                  <p className="text-danger mt-1 mb-0">{errors.location_id} </p>
                )}
              </Form.Group>
              <Form.Group className="col-12" controlId="formBasicCountry_code">
                <div className="phn_input">
                  <div className="phone-input">
                    <PhoneInput
                      name="country_code"
                      country={""}
                      disableTyping={true}
                      inputProps={{
                        readOnly: true,
                      }}
                      value={values.country_code}
                      onChange={(value) =>
                        handleChange({
                          target: {
                            name: "country_code",
                            value: `+${value}`,
                          },
                        })
                      }
                    />
                  </div>
                  <Form.Control
                    onKeyPress={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        isNaN(Number(e.key))
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    type="text"
                    pattern="[0-9]*"
                    name="contact_number"
                    value={values.contact_number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Number"
                  />
                </div>
                <Stack direction="horizontal" gap={2}>
                  {errors.country_code && touched.country_code && (
                    <p className="text-danger mt-1 mb-0">
                      {errors.country_code}
                    </p>
                  )}
                  {errors.contact_number && touched.contact_number && (
                    <p className="text-danger mt-1 mb-0">
                      {errors.contact_number}
                    </p>
                  )}
                </Stack>
              </Form.Group>
              <Form.Group
                className="col-12 col-sm-6"
                controlId="formBasicJobTitle"
              >
                <Form.Control
                  type="text"
                  name="job_title"
                  value={values.job_title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Job title"
                />
                {errors.job_title && touched.job_title && (
                  <p className="text-danger mt-1 mb-0">{errors.job_title} </p>
                )}
              </Form.Group>
              <Form.Group
                className="col-12 col-sm-6"
                controlId="formBasicEmployee_id"
              >
                <Form.Control
                  type="text"
                  name="employee_id"
                  value={values.employee_id}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Employee ID(optional)"
                />
                {errors.employee_id && touched.employee_id && (
                  <p className="text-danger mt-1 mb-0">{errors.employee_id} </p>
                )}
              </Form.Group>
              <Form.Group
                className="col-12 col-sm-6"
                controlId="formBasicAssigned_role"
              >
                <Form.Select
                  aria-label="Default select example"
                  name="assigned_role"
                  onChange={handleChangeValues}
                  value={values.assigned_role}
                >
                  <option value="" disabled className="option-title">
                    Assign Role
                  </option>
                  {assignDistributorRoles.map((curElm, index) => (
                    <option value={curElm.value} key={index}>
                      {curElm.label}
                    </option>
                  ))}
                </Form.Select>
                {errors.assigned_role && touched.assigned_role && (
                  <p className="text-danger mt-1 mb-0">
                    {errors.assigned_role}{" "}
                  </p>
                )}
              </Form.Group>
            </Row>
          </Col>
        </Row>
        <hr className="mb-4" />
        <Stack>
          <h6
            style={{
              styleName: "Category Head",
              fontFamily: "Open Sans",
              lineHeight: "15px",
              letterSpacing: "-0.011em",
              textAlign: "left",
            }}
            className="m-0 fw-bold"
          >
            Permissions
          </h6>
          <hr />
          <Row className="row-gap-3">
            {userPermissionsDistributor &&
              userPermissionsDistributor.slice(0, 3).map((curElm) => (
                <Col
                  xs={12}
                  sm={6}
                  md={4}
                  key={curElm.id}
                  className={curElm.column}
                >
                  <FormControlLabel
                    control={
                      <StyledSwitch
                        id={curElm.id}
                        onChange={handlePermissionChange}
                        checked={values.permissions.includes(curElm.id)}
                      />
                    }
                    label={curElm.label}
                    sx={{
                      mr: 0,
                      "& .MuiTypography-root": { fontSize: "14px" },
                    }}
                  />
                </Col>
              ))}
            {errors.permissions && touched.permissions && (
              <p className="text-danger mt-1 mb-0">{errors.permissions} </p>
            )}
          </Row>
        </Stack>
        <Row className="justify-content-end row-gap-3 align-items-center position-sticky bottom-0 bg-white footer-section">
          <Col xs={12}>
            <hr className="m-0" />
          </Col>
          {id && (
            <Col xs={12} md={id ? 6 : 12} lg={id ? 4 : 12}>
              <div className="disable_delete_action d-flex">
                <button className="user-mng-button disabled" type="button">
                  <Stack direction="horizontal" className="gap-2">
                    <img src={TrashIcon} alt="TrashIcon" />
                    Delete
                  </Stack>
                </button>
              </div>
            </Col>
          )}
          <Col xs={12} md={id ? 6 : 12} lg={id ? 8 : 12}>
            <div className="d-flex gap-3 justify-content-end flex-wrap-reverse">
              <NavLink
                className="nav-link d-flex flex-grow-1 flex-sm-grow-0"
                to="/distributor-user-management"
              >
                <CustomButton className="btn-dark flex-grow-1">
                  Cancel
                </CustomButton>
              </NavLink>
              <button
                type="submit"
                className="btn btn-primary px-sm-5 flex-grow-1 flex-sm-grow-0"
                disabled={status === StatusCode.LOADING}
              >
                {status === StatusCode.LOADING ? (
                  <ButtonLoader />
                ) : (
                  "Update Changes"
                )}
              </button>
            </div>
          </Col>
        </Row>
      </Stack>
    </Form>
  );
}

export default ManageDistributor;
